import React from "react";

import { ActualInventoryProvider } from "../../../context/ActualInventoryContext";
import { ActualInventoryList, ActualInventoryProps } from "./components/Inventory";
import { useOrderContext } from "Hooks/useOrderContext";
import { formatDateWithUserPref } from "Util/dateFormaterPreference";

const ActualInventory = (props: ActualInventoryProps) => {
  const { order } = useOrderContext();

  return (
    <ActualInventoryProvider fromBranchId={order?.branchFromId} toBranchId={order?.toBranchId}>
      <ActualInventoryList {...props} />
    </ActualInventoryProvider>
  );
};

export default ActualInventory;
